import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "src/store/rootReducer";

export const selectModelData = createSelector(
  [(state: RootState, modelName: string) => state.vpoStrapi.filtersData[modelName]?.data],
  (data) => data || []
);

export const selectModelLoading = createSelector(
  [(state: RootState, modelName: string) => state.vpoStrapi.filtersData[modelName]?.loading],
  (loading) => loading || false
);

export const selectModelError = createSelector(
  [(state: RootState, modelName: string) => state.vpoStrapi.filtersData[modelName]?.error],
  (error) => error || null
);